export enum MyClassesMenuOptionEnum {
    Today = 1,
    Scheduled = 2,
    Past = 3,
    Reports = 4

}
